import { Component, ViewEncapsulation } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { Register } from 'src/app/common-components/register/models/register';
import { getPhonePrivileges } from 'src/app/privileges/privileges.selector';
import { phoneRegisterColumns } from '../../helpers/phones-helper';
import { PhonePrivileges } from '../../models/phone-privileges';
import { PhoneRegisterOptions } from '../../models/phone-register-options';
import { PhoneRegisterListItem } from '../../models/phone-register-results.model';
import * as PhoneRegisterActions from '../state/phone-register.actions';
import { phoneRegisterAdapterActions } from '../state/phone-register.actions';
import * as phoneRegisterReducer from '../state/phone-register.reducer';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-phone-register',
    styleUrls: ['./phone-register.component.scss'],
    templateUrl: './phone-register.component.html',
    standalone: false
})
export class PhoneRegisterComponent extends Register<PhoneRegisterListItem, PhoneRegisterOptions, OrderingOption> {
   entityName = 'Phone';

   columns = phoneRegisterColumns;

   phonePrivileges$: Observable<PhonePrivileges>;

   constructor(public store: Store) {
      super(store, phoneRegisterReducer.selectors, phoneRegisterAdapterActions);
      this.phonePrivileges$ = store.pipe(select(getPhonePrivileges));
   }

   onCreate(): void {
      this.store.dispatch(PhoneRegisterActions.createPhone());
   }
}
